export const convertRewardDate = (value: string): string => {
  const [year, month, date] = value.split("-");
  return `${date}-${month}-${year}`;
};
